import { resolve } from "url";
import { map, take } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { AngularFirestore } from "@angular/fire/firestore";
@Injectable({
  providedIn: "root"
})
export class BookServiceService {
  constructor(private fs: AngularFirestore) {}

  // public news = [   {
  //     title: "Card Title 3",
  //     description:
  //       "Some quick example text to build on the card title and make up the bulk of the card content",
  //     buttonText: "Button",
  //     img: "../../../assets/img (51).jpg",

  //   },
  //   {
  //     title: "Card Title 4",
  //     description:
  //       "Some quick example text to build on the card title and make up the bulk of the card content",
  //     buttonText: "Button",
  //     img: "../../../assets/img (35).jpg",
  //   },
  //   {
  //     title: "Card Title 5",
  //     description:
  //       "Some quick example text to build on the card title and make up the bulk of the card content",
  //     buttonText: "Button",
  //     img: "../../../assets/img (45).jpg",
  //   },
  //   {
  //     title: "Card Title 6",
  //     description:
  //       "Some quick example text to build on the card title and make up the bulk of the card content",
  //     buttonText: "Button",
  //     img: "../../assets/emoji.png",
  //   }
  // ]
  getUsers() {
    return this.fs.collection("users").valueChanges();
  }
  getUser(id) {
    return this.fs
      .collection("users")
      .doc(id)
      .valueChanges();
  }
  editUser(id) {
    return this.fs.collection("users").doc(id);
  }
  removeUser(id) {
    return this.fs
      .collection("users")
      .doc(id)
      .delete();
  }

  allBooks() {
    return this.fs.collection("books").snapshotChanges();
  }
  news() {
    return this.fs.collection("news").snapshotChanges();
  }
  removePost(id) {
    return this.fs
      .collection("news")
      .doc(id)
      .delete();
  }
  AddPost({ title, description, image }) {
    return this.fs.collection("news").add({ title, description, image });
  }
  editPost(id) {
    return this.fs.collection("news").doc(id);
  }

  public async onePost(id) {
    let currentBook: any;
    await new Promise(resolve => {
      this.fs
        .collection("news")
        .doc(id)
        .valueChanges()
        .pipe(
          take(1),
          map(book => {
            return book;
          })
        )
        .subscribe(book => {
          resolve();
          currentBook = book;
        });
    }).catch(err => console.log(err));
    return currentBook;
  }
  gEtBook(id) {
    return this.fs
      .collection("books")
      .doc(id)
      .valueChanges();
  }
  userBooks() {
    return this.fs
      .collection("users")
      .doc("8Nqd3oc9nvUy07uuqukcCrxyyoE2")
      .valueChanges();
  }
  public async getBook(bookId: string) {
    let currentBook: any;
    await new Promise(resolve => {
      this.fs
        .collection("books")
        .doc(bookId)
        .valueChanges()
        .pipe(
          take(1),
          map(book => {
            return book;
          })
        )
        .subscribe(book => {
          resolve();
          currentBook = book;
        });
    }).catch(err => console.log(err));
    return currentBook;
  }

  AddBook({ title, description, image, rate }) {
    return this.fs.collection("books").add({ title, description, image, rate });
  }
  ediBook(id) {
    return this.fs.collection("books").doc(id);
  }
  removeBook(id) {
    return this.fs
      .collection("books")
      .doc(id)
      .delete();
  }
}
